module.exports = __webpack_public_path__ + "img/mobile-logo.58f68baa.svg";